import { render, staticRenderFns } from "./EventGalleryMenu.vue?vue&type=template&id=1955a250"
import script from "./EventGalleryMenu.vue?vue&type=script&lang=js"
export * from "./EventGalleryMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports